var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "markets-wrapper" }, [
    _vm.markets
      ? _c(
          "div",
          {
            staticClass: "markets",
            class: [
              { multiple: _vm.markets.length > 1 },
              { single: _vm.markets.length === 1 },
              { empty: _vm.markets.length === 0 }
            ]
          },
          [
            (["TENNIS", "SOCCER", "BOXING", "MMA"].indexOf(
              _vm.event.idfosporttype
            ) === -1 ||
              (["BOXING", "MMA"].indexOf(_vm.event.idfosporttype) > 0 &&
                !(_vm.brand_white1 || _vm.brand_translux5))) &&
            ((_vm.screenConfiguration.is2showeventsin2columns &&
              !_vm.screenConfiguration.is2showsingleevent &&
              !_vm.screenConfiguration.is2showoutrightevents) ||
              (_vm.screenConfiguration.is2showsingleevent &&
                _vm.forcenonbig3 !== true))
              ? [
                  _vm._l(_vm.big3columns, function(column) {
                    return [
                      column === "PS"
                        ? _c("big3market", {
                            attrs: {
                              market: _vm.pointsMarket,
                              showheader: _vm.showheader,
                              big3markettype: "PS"
                            }
                          })
                        : column === "TP"
                        ? _c("big3market", {
                            attrs: {
                              market: _vm.totalMarket,
                              showheader: _vm.showheader,
                              big3markettype: "TP"
                            }
                          })
                        : column === "ML"
                        ? _c("big3market", {
                            attrs: {
                              market: _vm.moneyMarket,
                              showheader: _vm.showheader,
                              big3markettype: "ML"
                            }
                          })
                        : _vm._e()
                    ]
                  })
                ]
              : (_vm.brand_white1 || _vm.brand_translux5) &&
                ["TENNIS", "SOCCER", "BOXING", "MMA"].indexOf(
                  _vm.event.idfosporttype
                ) > -1 &&
                (_vm.screenConfiguration.is2showeventsin2columns ||
                  _vm.screenConfiguration.is2showsingleevent) &&
                _vm.nonBig3TwoColumnsHadMarket
              ? [
                  _vm._l(["H", "D", "A"], function(hadvalue) {
                    return _vm.event.idfosporttype === "SOCCER" &&
                      _vm.brand_white1
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "market selection-wrapper had",
                              class: hadvalue
                            },
                            [
                              _vm.showheader
                                ? _c(
                                    "div",
                                    { staticClass: "header market-name-title" },
                                    [
                                      hadvalue === "A"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Market.Away"))
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      hadvalue === "D"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.$t("Market.Tie")))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      hadvalue === "H"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Market.Home"))
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("selection", {
                                attrs: {
                                  selection:
                                    _vm.nonBig3TwoColumnsHadMarket.selections.find(
                                      function(sel) {
                                        return (
                                          sel.hadvalue === hadvalue &&
                                          sel.idfoselectionsuspensiontype !==
                                            "N/O"
                                        )
                                      }
                                    ) || {},
                                  istradable:
                                    _vm.nonBig3TwoColumnsHadMarket.istradable,
                                  showselectionname: false,
                                  showshortselectionname: true,
                                  ishad: true
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(["A", "D", "H"], function(hadvalue) {
                    return _vm.event.idfosporttype === "SOCCER" &&
                      !_vm.brand_white1
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "market selection-wrapper had",
                              class: hadvalue
                            },
                            [
                              _vm.showheader
                                ? _c(
                                    "div",
                                    { staticClass: "header market-name-title" },
                                    [
                                      hadvalue === "A"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Market.Away"))
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      hadvalue === "D"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.$t("Market.Tie")))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      hadvalue === "H"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Market.Home"))
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("selection", {
                                attrs: {
                                  selection:
                                    _vm.nonBig3TwoColumnsHadMarket.selections.find(
                                      function(sel) {
                                        return (
                                          sel.hadvalue === hadvalue &&
                                          sel.idfoselectionsuspensiontype !==
                                            "N/O"
                                        )
                                      }
                                    ) || {},
                                  istradable:
                                    _vm.nonBig3TwoColumnsHadMarket.istradable,
                                  showselectionname: false,
                                  showshortselectionname: true,
                                  ishad: true
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.event.idfosporttype === "TENNIS" ||
                  _vm.event.idfosporttype === "BOXING" ||
                  _vm.event.idfosporttype === "MMA"
                    ? _c("div", { staticClass: "market big3" }, [
                        _vm.showheader
                          ? _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "market-name" }, [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "market-name-title text-overflow"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.nonBig3TwoColumnsHadMarket.name ===
                                          "Moneyline"
                                          ? _vm.$t("Market.MONEY")
                                          : _vm.nonBig3TwoColumnsHadMarket.name
                                      )
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "selections-container" }, [
                          _c("div", { staticClass: "selections had" }, [
                            _c(
                              "div",
                              { staticClass: "selections" },
                              _vm._l(["A", "H"], function(hadvalue) {
                                return _c(
                                  "div",
                                  { staticClass: "selection", class: hadvalue },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "selection-column" },
                                      [
                                        _c("selection", {
                                          attrs: {
                                            selection:
                                              _vm.nonBig3TwoColumnsHadMarket.selections.find(
                                                function(sel) {
                                                  return (
                                                    sel.hadvalue === hadvalue &&
                                                    sel.idfoselectionsuspensiontype !==
                                                      "N/O"
                                                  )
                                                }
                                              ) || {},
                                            istradable:
                                              _vm.nonBig3TwoColumnsHadMarket
                                                .istradable,
                                            showselectionname: false,
                                            showshortselectionname: false,
                                            ishad: true
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              : _vm._l(_vm.filteredMarkets, function(market) {
                  return _c(
                    "div",
                    {
                      key: market.idfomarket,
                      class: [
                        "market",
                        {
                          big3:
                            market.big3markettype &&
                            ["TENNIS", "SOCCER"].indexOf(
                              market.idfosporttype
                            ) === -1 &&
                            !_vm.is2displayhorizontally
                        },
                        { suspended: !market.istradable },
                        "selections-x" + market.selections.length,
                        { three: market.selections.length === 3 },
                        {
                          "more-than-three-selections":
                            market.selections.length > 3
                        },
                        { "multi-had": _vm.isMultiHad(market) },
                        { "outright-market": _vm.event.isoutright },
                        {
                          had: _vm.isHadMarketsPerIDFOMarket[market.idfomarket]
                        },
                        { "had-odd": market.hadOdd },
                        { "last-had": market.lastHad },
                        {
                          "non-had": !_vm.isHadMarketsPerIDFOMarket[
                            market.idfomarket
                          ]
                        },
                        {
                          handicap:
                            market.normalizedhandicapvalue ||
                            market.currentmatchhandicap
                        }
                      ],
                      attrs: {
                        idfomarket: market.idfomarket,
                        isfrompush: (market.V !== undefined).toString()
                      }
                    },
                    [
                      _vm.showheader === undefined || _vm.showheader
                        ? _c("div", { staticClass: "header" }, [
                            _c("div", { staticClass: "market-name" }, [
                              _c(
                                "h4",
                                {
                                  staticClass: "market-name-title text-overflow"
                                },
                                [_vm._v(_vm._s(market.name))]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDebug
                        ? _c("span", { staticClass: "debug" }, [
                            _vm._v("\n          " + _vm._s(market.idfomarket)),
                            _c("br"),
                            _vm._v(
                              "\n          isfrompush " +
                                _vm._s((market.V !== undefined).toString()) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "selections-container" }, [
                        market.selections &&
                        _vm.isHadMarketsPerIDFOMarket[market.idfomarket]
                          ? _c("div", { staticClass: "selections had" }, [
                              market.big3markettype &&
                              ["TENNIS", "SOCCER"].indexOf(
                                market.idfosporttype
                              ) === -1
                                ? _c(
                                    "div",
                                    {
                                      class: [
                                        "selections",
                                        {
                                          hasdraw:
                                            market.selections.filter(function(
                                              sel
                                            ) {
                                              return sel.hadvalue === "D"
                                            }).length > 0
                                        }
                                      ]
                                    },
                                    _vm._l(["A", "H", "O", "U"], function(
                                      hadvalue,
                                      index
                                    ) {
                                      return market.selections &&
                                        market.selections.filter(function(sel) {
                                          return (
                                            sel.hadvalue === hadvalue &&
                                            sel.idfoselectionsuspensiontype !==
                                              "N/O"
                                          )
                                        }).length
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "selection",
                                              class: hadvalue
                                            },
                                            _vm._l(
                                              market.selections.filter(function(
                                                sel
                                              ) {
                                                return (
                                                  sel.hadvalue === hadvalue &&
                                                  sel.idfoselectionsuspensiontype !==
                                                    "N/O"
                                                )
                                              }),
                                              function(selection) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      selection.idfoselection,
                                                    staticClass:
                                                      "selection-column"
                                                  },
                                                  [
                                                    _c("selection", {
                                                      attrs: {
                                                        selection: selection,
                                                        istradable:
                                                          market.istradable,
                                                        showselectionname:
                                                          false ||
                                                          _vm
                                                            .screenConfiguration
                                                            .is2showsingleevent,
                                                        ishad: true
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c(
                                    "div",
                                    {
                                      class: [
                                        "selections",
                                        {
                                          hasdraw:
                                            market.selections.filter(function(
                                              sel
                                            ) {
                                              return sel.hadvalue === "D"
                                            }).length > 0
                                        }
                                      ]
                                    },
                                    _vm._l(["H", "D", "A", "O", "U"], function(
                                      hadvalue,
                                      index
                                    ) {
                                      return market.selections &&
                                        market.selections.filter(function(sel) {
                                          return (
                                            sel.hadvalue === hadvalue &&
                                            sel.idfoselectionsuspensiontype !==
                                              "N/O"
                                          )
                                        }).length
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "selection",
                                              class: hadvalue
                                            },
                                            _vm._l(
                                              market.selections.filter(function(
                                                sel
                                              ) {
                                                return (
                                                  sel.hadvalue === hadvalue &&
                                                  sel.idfoselectionsuspensiontype !==
                                                    "N/O"
                                                )
                                              }),
                                              function(selection) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      selection.idfoselection,
                                                    staticClass:
                                                      "selection-column"
                                                  },
                                                  [
                                                    _c("selection", {
                                                      attrs: {
                                                        selection: selection,
                                                        istradable:
                                                          market.istradable,
                                                        showselectionname: true,
                                                        ishad: true
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        market.selections &&
                        !_vm.isHadMarketsPerIDFOMarket[market.idfomarket]
                          ? _c(
                              "div",
                              { staticClass: "selections non-had" },
                              [
                                !market.isoutright
                                  ? _vm._l(
                                      _vm.vue._.orderBy(
                                        market.selections,
                                        "internalorder"
                                      ).filter(function(sel) {
                                        return (
                                          sel.idfoselectionsuspensiontype !==
                                          "N/O"
                                        )
                                      }),
                                      function(selection) {
                                        return _c(
                                          "span",
                                          {
                                            key: selection.idfoselection,
                                            staticClass: "selection"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "selection-column"
                                              },
                                              [
                                                _c("selection", {
                                                  attrs: {
                                                    selection: selection,
                                                    istradable:
                                                      market.istradable,
                                                    showselectionname: true,
                                                    ishad: false
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._l(
                                      _vm.outrightSelectionsColumns,
                                      function(column) {
                                        return _c(
                                          "div",
                                          {
                                            class: [
                                              "selection-col",
                                              "no" + column
                                            ]
                                          },
                                          _vm._l(
                                            _vm.vue._.orderBy(
                                              market.selections,
                                              [
                                                "internalorder",
                                                "currentprice",
                                                "name"
                                              ]
                                            ).filter(function(sel) {
                                              return (
                                                sel.selectioncolumn ===
                                                  column &&
                                                sel.idfoselectionsuspensiontype !==
                                                  "N/O"
                                              )
                                            }),
                                            function(selection) {
                                              return _c(
                                                "span",
                                                {
                                                  key: selection.idfoselection,
                                                  staticClass: "selection"
                                                },
                                                [
                                                  _c("selection", {
                                                    attrs: {
                                                      selection: selection,
                                                      istradable:
                                                        market.istradable,
                                                      showselectionname: true,
                                                      isoutright: true,
                                                      ishad: false
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      }
                                    )
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9b57816", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9b57816","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/markets.vue
// module id = null
// module chunks = 